import { SVG } from '../../SVG'

const CalgaryLogoCollapsed = ({ style = {}, ...props }) => (
  <SVG
    width='100%'
    height='100%'
    viewBox='0 0 200 200'
    enableBackground='new 0 0 200 200'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path
      fill='#FEFFFF'
      opacity='1.000000'
      stroke='none'
      d='
M127.000000,201.000000
	C84.692825,201.000000 42.885651,201.000000 1.039238,201.000000
	C1.039238,134.401199 1.039238,67.802368 1.039238,1.101770
	C67.556999,1.101770 134.114197,1.101770 200.835693,1.101770
	C200.835693,67.666336 200.835693,134.333130 200.835693,201.000000
	C176.469315,201.000000 151.984665,201.000000 127.000000,201.000000
M123.499908,162.710663
	C135.958252,162.710663 148.416580,162.710663 161.185608,162.710663
	C161.185608,121.597420 161.185608,80.916298 161.185608,40.336918
	C120.288574,40.336918 79.734138,40.336918 39.316154,40.336918
	C39.316154,81.235382 39.316154,121.793755 39.316154,162.710587
	C67.255455,162.710587 94.877678,162.710587 123.499908,162.710663
z'
    />
    <path
      fill='#025877'
      opacity='1.000000'
      stroke='none'
      d='
M122.999908,162.710632
	C94.877678,162.710587 67.255455,162.710587 39.316154,162.710587
	C39.316154,121.793755 39.316154,81.235382 39.316154,40.336918
	C79.734138,40.336918 120.288574,40.336918 161.185608,40.336918
	C161.185608,80.916298 161.185608,121.597420 161.185608,162.710663
	C148.416580,162.710663 135.958252,162.710663 122.999908,162.710632
M50.296745,60.392185
	C48.559139,67.022423 50.620201,72.279205 55.458523,77.063797
	C64.062988,85.572685 72.319801,94.433128 80.795532,103.222740
	C79.620506,104.607857 78.919937,105.525635 78.126602,106.354637
	C70.181503,114.657036 62.214100,122.938095 54.267746,131.239304
	C49.515026,136.204254 48.348755,143.308731 51.366608,148.688782
	C56.299492,157.482819 66.832115,158.771042 74.064529,151.320129
	C82.853905,142.265213 91.509552,133.080490 98.751846,125.493195
	C108.180733,134.079697 117.182198,142.506104 126.476692,150.595795
	C129.124756,152.900604 132.437210,155.104630 135.773117,155.815857
	C142.309738,157.209427 147.742126,153.946640 150.547623,148.188431
	C153.238190,142.666107 152.234482,136.954788 147.639771,132.151031
	C138.573196,122.671906 129.475662,113.222374 120.300415,103.666313
	C121.336418,102.406616 122.010681,101.469276 122.801392,100.643433
	C130.978210,92.103249 139.257095,83.659004 147.336823,75.028206
	C153.376007,68.577118 153.407944,60.009689 147.714523,54.373520
	C142.391678,49.104195 133.025787,49.558758 127.047562,55.486153
	C124.211479,58.298122 121.661461,61.400711 118.798935,64.183487
	C112.630096,70.180443 106.342934,76.055687 98.981178,83.047287
	C97.842651,81.444168 96.681198,79.353287 95.097084,77.657150
	C88.277451,70.355331 81.430634,63.073677 74.409889,55.966270
	C66.277145,47.733131 56.099522,49.389614 50.296745,60.392185
z'
    />
    <path
      fill='#76BB20'
      opacity='1.000000'
      stroke='none'
      d='
M50.469826,60.021580
	C56.099522,49.389614 66.277145,47.733131 74.409889,55.966270
	C81.430634,63.073677 88.277451,70.355331 95.097084,77.657150
	C96.681198,79.353287 97.842651,81.444168 98.981178,83.047287
	C106.342934,76.055687 112.630096,70.180443 118.798935,64.183487
	C121.661461,61.400711 124.211479,58.298122 127.047562,55.486153
	C133.025787,49.558758 142.391678,49.104195 147.714523,54.373520
	C153.407944,60.009689 153.376007,68.577118 147.336823,75.028206
	C139.257095,83.659004 130.978210,92.103249 122.801392,100.643433
	C122.010681,101.469276 121.336418,102.406616 120.300415,103.666313
	C129.475662,113.222374 138.573196,122.671906 147.639771,132.151031
	C152.234482,136.954788 153.238190,142.666107 150.547623,148.188431
	C147.742126,153.946640 142.309738,157.209427 135.773117,155.815857
	C132.437210,155.104630 129.124756,152.900604 126.476692,150.595795
	C117.182198,142.506104 108.180733,134.079697 98.751846,125.493195
	C91.509552,133.080490 82.853905,142.265213 74.064529,151.320129
	C66.832115,158.771042 56.299492,157.482819 51.366608,148.688782
	C48.348755,143.308731 49.515026,136.204254 54.267746,131.239304
	C62.214100,122.938095 70.181503,114.657036 78.126602,106.354637
	C78.919937,105.525635 79.620506,104.607857 80.795532,103.222740
	C72.319801,94.433128 64.062988,85.572685 55.458523,77.063797
	C50.620201,72.279205 48.559139,67.022423 50.469826,60.021580
z'
    />
  </SVG>
)

export default CalgaryLogoCollapsed
